export default class {
  constructor({
    handle,
    inputGroupSelector
  }) {
    // Get the input groups
    let inputGroups = document.querySelectorAll(inputGroupSelector);

    /**
     * Progressively set styles on connect form
     *
     */
    const setProgressiveStyles = (group, styleSettings) => {
      let groupLabel = group.querySelector('label');

      // Set containing group styles
      group.style.position = styleSettings.group.position;

      // Set label styles
      groupLabel.style.position = styleSettings.label.position;
      groupLabel.style.top = styleSettings.label.top;
      groupLabel.style.left = styleSettings.label.left;
      groupLabel.style.color = styleSettings.label.color;
    }

    let styleSettings = {
      "group": {
        "position": "relative",
      },
      "label": {
        "position": "absolute",
        "top": "15px",
        "left": "15px",
        "color": "#666",
      }
    };

    Array.from(inputGroups).forEach(group => {
      setProgressiveStyles(group, styleSettings);
    });

    /**
     * Handle inputs being focused and blurred
     * (hide label)
     */
    const handleFocus = (group) => {
      let groupLabel = group.querySelector('label');

      groupLabel.style.opacity = 0;
    }

    const handleBlur = (group) => {
      let groupLabel = group.querySelector('label'),
        groupInput = group.querySelector('input, select');

      if (groupInput.value === '') {
        groupLabel.style.opacity = 100;
      }
    }

    Array.from(inputGroups).forEach(group => {
      let input = group.querySelector('input');
      let select = group.querySelector('select');

      if (input !== null) {
        input.addEventListener('focus', function() {
          handleFocus(group);
        });
        input.addEventListener('blur', function() {
          handleBlur(group);
        });

        if (input.value != '') {
          handleFocus(group);
        }
      }

      if (select !== null) {
        select.addEventListener('focus', function() {
          handleFocus(group);
        });
        select.addEventListener('blur', function() {
          handleBlur(group);
        });

        if (select.selectedIndex !== -1 && select.selectedIndex !== 0) {
          handleFocus(group);
        }
      }
    });
  }
}